import { makeStyles } from '@material-ui/core';
var possibleMovementsStyles = makeStyles(function (theme) { return ({
    wrenchIcon: {
        transform: "rotateZ(90deg)",
        color: '#676767',
        cursor: 'pointer'
    },
}); });
export default possibleMovementsStyles;
//# sourceMappingURL=styles.js.map